@if (paragraph$ | async; as data) { @if ( data['uid'] === 'ImportCSVSavedCartInstructionsComponent' || data['uid'] ===
'OrderInfoTitleComponent' || data['uid'] === 'OrderDetailsTitleComponent') {
<div [ngClass]="data['styleClass']">
  <div [innerHTML]="updateRelativePath(data['content'])"></div>
</div>
} @else { @if ( (currentPageTemplate$ | async) !== 'MyAccountDiscountsPageTemplate' ||
!paragraphUid.includes('BucketType')) {
<div [ngClass]="data['styleClass']">
  <p [innerHTML]="updateRelativePath(data['content']) | safeHtml"></p>
</div>
} @else { @if (paragraphUid.includes('BucketType') && paragraphUid.includes(discountType)) {
<div [ngClass]="data['styleClass']">
  <p [innerHTML]="updateRelativePath(data['content'])"></p>
</div>
} } } }
